import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile, isTablet } from 'react-device-detect'

import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericColumn from '../../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'

import { SectionContainer, StarImage, TransformationImageButton, TransformationImageContainer } from '../../style/LandingStyle'



interface TransformationsSectionInterface { }

const TransformationsSection: FC<TransformationsSectionInterface> = ({ }) => {

  const [activeImage, setActiveImage] = useState<number>(1)


  const switchImage = (mode: string) => {

    if (mode == "next") {
      activeImage == 6 ? setActiveImage(1) : setActiveImage(activeImage + 1)
    }
    if (mode == "prev") {
      activeImage == 1 ? setActiveImage(6) : setActiveImage(activeImage - 1)
    }
  }

  return (
    <SectionContainer className="transformation" margin={"7% 0 0 0"}>
      <GenericRow wrap={isMobile ? "wrap" : "unset"}>
        <GenericColumn order={isMobile ? 2 : 1} width={isMobile ? "100%" : "60%"}>
          <GenericRow justify="space-around">
            <TransformationImageButton onClick={() => switchImage("prev")} className="left" />
            {isMobile && !isTablet ? <GenericColumn>
              <TransformationImageContainer activeImage={activeImage} className="before left" />
              <TransformationImageContainer activeImage={activeImage} className="after right" />
            </GenericColumn> : <>

              <TransformationImageContainer activeImage={activeImage} className="before left" />
              <TransformationImageContainer activeImage={activeImage} className="after right" />

            </>}
            <TransformationImageButton onClick={() => switchImage("next")} className="right" />
          </GenericRow>

        </GenericColumn>

        <GenericColumn order={isMobile ? 1 : 2} width={isMobile ? "100%" : "40%"} padding="0 10% 0 6%">
          <GenericTextSpan fWeight="bold" lineHeight="3.5rem" display="block" width="100%" tAlign={isMobile ? "center" : "left"} fSize="3.2rem">Przemiany kobiet</GenericTextSpan>
          <GenericTextSpan margin={isMobile ? "5% 0 5% 0" : "10% 0 0 0"} lineHeight="1.5rem" display="block" width="100%" tAlign={isMobile ? "center" : "left"} fSize={isMobile ? "1.1rem" : "1rem"}>A jak żeś niedowiarek, że to DZIAŁA i
            że MOŻNA, zobacz przemiany kobiet, które nie szukały wymówek.

</GenericTextSpan>
        </GenericColumn>
      </GenericRow>


    </SectionContainer>
  )
}

export default TransformationsSection
